import { Icon, type IconProps } from "../icon";

const PATHS = [
  "M16 17C16 15.8954 15.1046 15 14 15C12.8954 15 12 15.8954 12 17C12 18.1046 12.8954 19 14 19C15.1046 19 16 18.1046 16 17ZM18 17C18 19.2091 16.2091 21 14 21C11.7909 21 10 19.2091 10 17C10 14.7909 11.7909 13 14 13C16.2091 13 18 14.7909 18 17Z",
  "M21 16C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18H17C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16H21Z",
  "M6 12C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H3C2.44772 14 2 13.5523 2 13C2 12.4477 2.44772 12 3 12H6Z",
  "M2 15V11.0703C2.00002 10.0723 2.49831 9.11619 3.36914 8.57031L3.91211 8.23633C9.50018 4.86875 14.4395 4 21 4C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6C14.478 6 9.83469 6.87716 4.43066 10.2646C4.16843 10.4291 4.00002 10.731 4 11.0703V15C4 15.5523 4.44772 16 5 16H11C11.5523 16 12 16.4477 12 17C12 17.5523 11.5523 18 11 18H5C3.34315 18 2 16.6569 2 15Z",
];

export function CoupeIcon(props: IconProps) {
  return <Icon viewBox="0 0 24 24" paths={PATHS} {...props} />;
}
